module.exports = __webpack_public_path__ + "img/icon_coupon-code.784d87ee.svg";